export const SHOPIFY_RETAILERS_REDIRECT_URI = 'SHOPIFY_RETAILERS_REDIRECT_URI';
export const SHOPIFY_RETAILERS_FINISHED = 'SHOPIFY_RETAILERS_FINISHED';
export const SHOPIFY_CUSTOMER_ID = 'SHOPIFY_CUSTOMER_ID';

export const SHOPIFY_CUSTOMER_TYPE = {
  ACCOUNT_ID: 'account_id',
  END_CUSTOMER: 'end_customer',
};
